import * as Yup from 'yup';
import { VERIFICATION_CODE_LENGTH } from '../constants/mfa';

export const codeSchema = Yup.object({
  code: Yup.string()
    .length(VERIFICATION_CODE_LENGTH, 'invalidVerificationCode')
    .required('requiredField'),
});
